import { render, staticRenderFns } from "./StatementsItem.vue?vue&type=template&id=732704cd&scoped=true&"
import script from "./StatementsItem.vue?vue&type=script&lang=ts&"
export * from "./StatementsItem.vue?vue&type=script&lang=ts&"
import style0 from "./StatementsItem.vue?vue&type=style&index=0&id=732704cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732704cd",
  null
  
)

export default component.exports